/**
 * Hierarchical react-query keys for the Flyer Review feature.
 *
 * Everything is namespaced under a single root so the whole feature cache can
 * be invalidated/garbage-collected in isolation and never collides with the
 * rest of the app (which does not use react-query). `changeRequests` and
 * `comments` are siblings under `activity` so a change-request socket event
 * can invalidate only change requests without refetching comments (and vice
 * versa) — fixing the previous "reload everything" behavior.
 */
const ROOT = "flyer-review" as const;

export const reviewKeys = {
  all: [ROOT] as const,

  bootstrap: (flyerId: string) => [ROOT, "bootstrap", flyerId] as const,

  snapshot: (flyerId: string) => [ROOT, "snapshot", flyerId] as const,

  activityRoot: (flyerId: string) => [ROOT, "activity", flyerId] as const,
  changeRequests: (flyerId: string) =>
    [ROOT, "activity", flyerId, "changeRequests"] as const,
  comments: (flyerId: string) =>
    [ROOT, "activity", flyerId, "comments"] as const,

  itemSummariesRoot: () => [ROOT, "itemSummary"] as const,
  itemSummary: (itemId: string) => [ROOT, "itemSummary", itemId] as const,

  itemInspectorRoot: () => [ROOT, "itemInspector"] as const,
  itemInspector: (itemId: string) =>
    [ROOT, "itemInspector", itemId] as const,

  crHistory: (flyerItemId: string, fieldKey: string) =>
    [ROOT, "crHistory", flyerItemId, fieldKey] as const,
};
